import { cn } from '@/utils/styles';
import { Link } from '@design-system/Link';
import { Button } from '@design-system/Button';
import { NavBar } from '@design-system/NavBar';
import { Avatar } from '@design-system/Avatar';
import { SETTINGS_PATH } from '@/constants/paths';
import { SettingsIcon } from '@/components/icons/SettingsIcon';
import { useUserDetails } from '@/hooks/useUserDetails';

export interface AccountManagementPageProfileSectionProps
  extends React.ComponentProps<'div'> {
  className?: string;
}

export const AccountManagementPageProfileSection = ({
  className,
  ...props
}: AccountManagementPageProfileSectionProps) => {
  const { firstName } = useUserDetails();

  return (
    <div className={cn('flex flex-col', className)} {...props}>
      <NavBar hideReturnButton data-testid="accountProfile-navbar">
        <Button asChild variant="ghost" size="icon" data-testid="accountProfile-settingsButton">
          <Link to={SETTINGS_PATH} className="[&_svg]:!size-6">
            <SettingsIcon aria-label="My profile settings" />
          </Link>
        </Button>
      </NavBar>

     <Avatar size="large" username={firstName} data-testid="accountProfile-avatar" />
    </div>
  );
};
